module.exports = __webpack_public_path__ + "res/img/picbig.84c1665b.png";